import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthRoute = ({ children, requiredPermissions = [], requiredRoles = [] }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    // Проверка прав доступа
    const hasPermissions = requiredPermissions.every(permission =>
        user?.permissions?.includes(permission)
    );

    // Проверка ролей: если список ролей не пуст, то хотя бы одна должна присутствовать у пользователя
    const hasRoles = requiredRoles.length === 0 || requiredRoles.some(role =>
        user?.roles?.includes(role)
    );

    if ((!hasPermissions || !hasRoles) && (requiredPermissions.length > 0 || requiredRoles.length > 0)) {
        return <Navigate to="/unauthorized" state={{ from: location }} />;
    }

    return children;
};

export default AuthRoute;
